export default
    {
        // url: this.$store.state.http.riesgo.YYYY,
        guardaEntradaRiesgo: "/calidadRiesgo/guardaEntradaRiesgo",
        listRiesgos: "/calidadRiesgo/listRiesgos",
        listEstandares: "/calidadRiesgo/listEstandares",
        listTiposRiesgos: "/calidadRiesgo/listTiposRiesgos",
        listTiposRiesgosTrabajo: "/calidadRiesgo/listTiposRiesgosTrabajo",
        listLugaresRiesgos: "/calidadRiesgo/listLugaresRiesgos",
        listResponsablesRiesgos: "/calidadRiesgo/listResponsablesRiesgos",
        imprimeTrabajo: "/calidadRiesgo/imprimeTrabajo",
    }
